var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#00A0F3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2527 19.4476L11.1013 18.5892C11.3021 18.386 11.3021 18.0566 11.1013 17.8533L4.45284 11.1273H19.0856C19.3696 11.1273 19.5999 10.8943 19.5999 10.607V9.393C19.5999 9.10567 19.3696 8.8727 19.0856 8.8727H4.45284L11.1013 2.14662C11.3021 1.94345 11.3021 1.61402 11.1013 1.4108L10.2527 0.552405C10.0519 0.349231 9.72629 0.349231 9.52542 0.552405L0.550524 9.63212C0.349695 9.83529 0.349695 10.1647 0.550524 10.3679L9.52542 19.4476C9.72625 19.6508 10.0519 19.6508 10.2527 19.4476Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.1cc3aac8.svg";
export { ForwardRef as ReactComponent };